import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ButtonProps } from '@mui/material/Button';
// import styled from 'styled-components';
import { LinkButton } from './link-button';

interface NewButtonProps {
  text?: string;
  path?: string;
  fullWidth?: boolean;
  variant?: ButtonProps['variant'];
  children?: React.ReactNode;
}
export const BackButton: React.FC<NewButtonProps> = ({
  text,
  path,
  fullWidth = false,
  variant,
}) => {
  const location = useLocation();
  const backPathMatch = location.pathname.match(
    /(.*?)(?:(?:\/new)|(?:\/edit\/[^/]*?))$/,
  );

  const defaultBackPath = (backPathMatch && backPathMatch[1]) || path;
  const { t } = useTranslation();

  return (
    <LinkButton
      to={defaultBackPath ? `${defaultBackPath}` : '/'}
      fullWidth={fullWidth}
      variant={variant}
    >
      {String(t(text || `global.navigation.back`))}
    </LinkButton>
  );
};
